import { isThisYear, isToday } from 'date-fns'
import { action, computed, makeObservable, observable } from 'mobx'

import { notificationController } from '@/controller/notification.controller'
import { localStorageService } from '@/service/storage.service'
import dateUtils from '@/utils/DateUtils'

import { DTO } from '../DTO'

export type NotificationTypes =
  | 'MATHFLAT_FINISH'
  | 'MATHFLAT_FILE_DOWNLOAD'
  | 'MATHFLAT_FILE_DOWNLOAD_API'
  | 'MATHFLAT_REDIRECT'
  | 'MATHFLAT_MESSAGAE'
export type NotificationCase =
  | 'EMAIL'
  | 'GROUP_REPORT_CREATE'
  | 'GROUP_REPORT_UPDATE'
  | 'ONE_CLICK_REPORT'
  | 'ONE_CLICK_REPORT_CAS'
  | 'ACHIEVEMENT_REPORT_CREATE'
export type NotificationState = 'FAILURE' | 'SUCCESS' | 'START'
export type NotificationCTA =
  | 'NONE'
  | 'READ'
  | 'FILE_DOWNLOAD'
  | 'FILE_DOWNLOAD_API'
  | 'REDIRECT'
  | 'FILE_DOWNLOAD_ID_LIST'
  | 'PREVIEW'
  | 'CLIENT_NOTIFICATION_PUBLIC_WORKBOOK_OPEN'
  | 'CLIENT_NOTIFICATION_ESSAY_WORKSHEET_OPEN'
export type NotificationCTAOption = {
  onCTAClick?: (e: React.MouseEvent) => void
  text?: string
  className?: string
}
export type NotificationServeType = 'SERVER' | 'CLIENT' // 메세징 서버에서 받아오는 알람 | FE(CLIENT)에서 생성하는 알림 구분
export class Notification extends DTO {
  readonly serveType: NotificationServeType
  sortKey: number
  isRead: boolean
  message: string
  title: null | string
  createdAt: Date
  expiredAt: Date
  type: NotificationTypes
  id: string
  ids: string[]
  case2: NotificationCase
  state: NotificationState
  payload: any
  ctas: notification.CTA[]

  constructor(res: res.Notification, serveType: NotificationServeType = 'SERVER') {
    super()
    makeObservable(this, {
      sortKey: observable,
      isRead: observable,
      message: observable,
      title: observable,
      createdAt: observable,
      expiredAt: observable,
      type: observable,
      id: observable,
      ids: observable,
      case2: observable,
      state: observable,
      payload: observable,
      isTodayNotification: computed,
      formatToNotificationDatetime: computed,
      read: action,
      readAndFetch: action,
      ctas: observable,
      serveType: observable,
    })

    this.isRead = res.read
    this.expiredAt = new Date(res.expireDateTime)
    this.createdAt = new Date(res.createDateTime)
    this.message = res.data.payload.message
    this.title = res.data.payload.title
    this.sortKey = res.sortKey
    this.type = res.data.payload.type
    this.id = res.data.payload.id ?? ''
    this.ids = res.data.payload.ids ?? []
    this.case2 = res.data.payload.case
    this.state = res.data.payload?.state
    this.payload = res.data.payload
    this.ctas = res.data.cta
    this.serveType = serveType
  }

  get isTodayNotification() {
    return isToday(this.createdAt)
  }
  get formatToNotificationDatetime() {
    if (this.isTodayNotification) return dateUtils.to오늘HourMinute(this.createdAt)
    if (isThisYear(this.createdAt)) return dateUtils.toKoMonthDay(this.createdAt)
    return dateUtils.toKoFullDate(this.createdAt)
  }

  read = () => {
    if (!this.isRead) {
      this.isRead = true
    }
  }
  readAndFetch = () => {
    if (!this.isRead) {
      const partitionKey = this.partitionKey

      this.isRead = true
      notificationController.readItem({
        partitionKey,
        params: { sortKey: this.sortKey },
      })
    }
  }

  private get partitionKey() {
    const academyId = localStorageService.getItem('ACADEMY_ID')!
    const teacherId = localStorageService.getItem('teacher-id')!
    return `${academyId}.${teacherId}`
  }
}
